export const LimitsPeriod = {
  Day: 'day',
  Month: 'month',
  Week: 'week'
};
